module.exports = __webpack_public_path__ + "img/money.c14dc99c.svg";